export const getPhoneNumber = (state) => state?.signUp?.sinUpInfo?.phoneNumber;
export const getSessionToken = (state) => state?.signUp?.sinUpInfo?.sessionToken;
export const getAuthFlowToken = (state) => state?.signUp?.sinUpInfo?.authFlowToken;
